import { useMemo } from 'react';
import moment from 'moment';
import map from 'lodash/map';
import includes from 'lodash/includes';
import forEach from 'lodash/forEach';
export const useChartsConfig = (calculationFormula, customRanges)=>{
    const customRangesLabels = useMemo(()=>map(customRanges, (bp)=>bp[2]), [
        customRanges
    ]);
    const unitSymbol = useMemo(()=>{
        if (includes([
            'HYPERGLYCEMIA',
            'HYPOGLYCEMIA'
        ], calculationFormula)) {
            return '%';
        }
        return null;
    }, [
        calculationFormula
    ]);
    const ticks = useMemo(()=>{
        const start = moment().utc().locale('en--account');
        const end = moment().utc().locale('en--account');
        const ticksPoints = [];
        start.startOf('day');
        end.endOf('day');
        ticksPoints.push(+start.format('X'));
        const breakpoints = [
            ...customRanges
        ];
        breakpoints.shift();
        forEach(breakpoints, (hourBreakpoint)=>{
            ticksPoints.push(+start.hour(hourBreakpoint[0]).minutes(hourBreakpoint[1]).format('X'));
        });
        ticksPoints.push(+end.format('X') + 1);
        return ticksPoints;
    }, [
        customRanges
    ]);
    return {
        customRangesLabels,
        unitSymbol,
        ticks
    };
};
